(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/constants/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/tipsen/constants/assets/javascripts/constants.js');
"use strict";

const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_MD = _svs$components$lbUti.BREAKPOINT_MD;

const STATISTIC_SIDEBAR_QUERY = breakpoints.up(BREAKPOINT_MD);
setGlobal('svs.components.tipsen.constants', {
  STATISTIC_SIDEBAR_QUERY
});

 })(window);